<template lang="pug">
  v-container.fill-height.d-flex.align-center.justify-center.pa-0(max-width="600px")
    v-card(flat width="800px" class="rounded-card mx-auto" d-flex justify-center)
      v-snackbar( v-model="snackBar" :color="snackBarColor" ) {{ snackBarMessage }}
        template( v-slot:action="{attrs}")
          v-btn(text v-bind="attrs" @click="snackBar = false")
            v-icon fas fa-times
      v-container.pl-0(v-if="!isFetchInProgress")
        v-card.elevation-0(flat)
          v-list.ml-6.mb-0(dense)
            v-list-item
              v-list-item-content.mb-0.pb-0
                v-text-field.pb-0.pl-2(outlined :label="$t('settingsPage.offerStructure.loginName')" :disabled="fetchInProgress" v-model="loginName.value")
            v-list-item.mt-0.pt-0
              v-list-item-content
                v-checkbox.mt-0.pl-2(:label="$t('settingsPage.offerStructure.freePortion')" :disabled="fetchInProgress" v-model="isFreePortion.value" on-icon="fas fa-check-square"
                  off-icon="far fa-square"
                )
            v-list-item.mt-0.pt-0
              v-list-item-content
                v-checkbox.mt-0.pl-2(:label="$t('settingsPage.offerStructure.controlOrder')" :disabled="fetchInProgress" v-model="isControlOrder.value" on-icon="fas fa-check-square"
                  off-icon="far fa-square"
                )
            v-row.ma-0.ml-4
              v-list-item-action
                v-btn.mb-6.ml-2(@click="onSaveButtonClick" color="primary" :loading="fetchInProgress") {{ $t('settingsPage.offerStructure.slotEditorSaveButtonLabel') }}


      v-skeleton-loader(v-if="isFetchInProgress"
        type="list-item@12"
        width="100%")

</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action} from "vuex-class";
import DeleteTokenDialog from "@/components/settings/DeleteTokenDialog.vue";
import {GET_KEY, GET_SETTING_DATA, SAVE_NEW_SETTING, SAVE_SETTINGS} from "@/store/action-types";
import {SettingsPayload} from "@/types/payload";
import KeyList from "@/model/KeyList";
import SettingsKeyList from "@/model/SettingsKeyList";

@Component({
  components: {
    DeleteTokenDialog
  }
})
export default class GeneralSettingsPage extends Vue {

  @Action(GET_KEY) fetchKey!: ({ (): Promise<any[]> })
  @Action(GET_SETTING_DATA) fetchSettingData!: ({ (): Promise<SettingsKeyList[]> })
  @Action(SAVE_NEW_SETTING) onSaveNewSetting!: ({ (payload: SettingsPayload): Promise<void> })
  @Action(SAVE_SETTINGS) createSettings!: ({ (payload: any): Promise<void> })

  private fetchInProgress: boolean = false
  private isFetchInProgress: boolean = false
  private snackBar: boolean = false
  private snackBarMessage: string = ''
  private snackBarColor: string = ''
  private defaultValue: string | null = null
  private keyList: KeyList[] | null = []
  private setttingsKeyList: SettingsKeyList[] | null = []
  private loginName: any = {
    id: '',
    key: 'tenant.login_name_prefix',
    value: 'lm',
    name: '',
    type: ''
  }
  private isFreePortion: any = {
    id: '',
    key: 'tenant.allow_portions_count',
    value: false,
    name: '',
    type: ''
  }
  private isControlOrder: any = {
    id: '',
    key: 'tenant.allow_acceptance_process',
    value: true,
    name: '',
    type: ''
  }

  getData() {
    this.setttingsKeyList!.forEach((item: SettingsKeyList) => {
      const foundItem: KeyList | undefined = this.keyList!.find((i: KeyList) => item.name == i.key)
      if(foundItem) {
        if(item.name === 'tenant.login_name_prefix') {
          this.loginName = {
            id: foundItem.id,
            key: foundItem.key,
            value: foundItem.value ? foundItem.value : item.defaultValue,
            name: item.name,
            type: item.type
          }
        } else if (item.name === 'tenant.allow_portions_count') {
          this.isFreePortion = {
            id: foundItem.id,
            key: foundItem.key,
            value: foundItem.value ? foundItem.value === 'true' ? true : false : item.defaultValue === 'true' ? true : false,
            name: item.name,
            type: item.type
          }
        } else if(item.name === 'tenant.allow_acceptance_process') {
          this.isControlOrder = {
            id: foundItem.id,
            key: foundItem.key,
            value: foundItem.value ? foundItem.value === 'true' ? true : false : item.defaultValue === 'true' ? true : false,
            name: item.name,
            type: item.type
          }
        }
      }
    })
  }

  onSaveButtonClick (): void {
    if(this.loginName.id) {
      const payload1: SettingsPayload = {
        id: this.loginName.id,
        value: this.loginName.value
      }
      this.saveSettings(payload1)
    }else{
      const payload: any = {
        value: this.loginName.value,
        key: this.loginName.key
      }
      this.createNewSettings(payload)
    }

    if(this.isFreePortion.id) {
      const payload2: SettingsPayload = {
        id: this.isFreePortion.id,
        value: this.isFreePortion.value
      }
      this.saveSettings(payload2)
    } else {
      const payload1: any = {
        value: this.isFreePortion.value,
        key: this.isFreePortion.key
      }
      this.createNewSettings(payload1)
    }
    if(this.isControlOrder.id) {
      const payload3: SettingsPayload = {
        id: this.isControlOrder.id,
        value: this.isControlOrder.value
      }
      this.saveSettings(payload3)
    } else {
      const payload1: any = {
        value: this.isControlOrder.value,
        key: this.isControlOrder.key
      }
      this.createNewSettings(payload1)
    }


  }

  async saveSettings(payload: SettingsPayload): Promise<void> {
      this.fetchInProgress = true
      try {
      await this.onSaveNewSetting(payload)
    }catch (e) {
      this.snackBar = true
      this.snackBarColor="error"
      this.snackBarMessage=this.$t('settingsPage.offerStructure.snackbarErrorSaveMessage').toString()
    }finally {
        this.fetchInProgress = false
        this.snackBar = true
        this.snackBarColor="success"
        this.snackBarMessage=this.$t('settingsPage.offerStructure.saved').toString()
      }
  }

  async createNewSettings(payload: any):Promise<void> {
    /*const payload: any = {
      value: this.isFreePortion.value,
      key: this.isFreePortion.key
    }*/
    try {
      await this.createSettings(payload)
    } catch (e) {

    }
  }

  async fetchData(): Promise<void> {
    let promiseList: Promise<any[]>[] = []
    promiseList.push(this.fetchSettingsKeys())
    promiseList.push(this.fetchSettingsData())
    await Promise.all(promiseList)
    this.getData()
  }

  async fetchSettingsKeys(): Promise<any> {
    try {
      this.isFetchInProgress = true
      this.keyList = await this.fetchKey()
    } catch (e) {
      this.snackBar = true
      this.snackBarColor="error"
      this.snackBarMessage=this.$t('settingsPage.offerStructure.snackbarErrorMessage').toString()
    }finally {
      this.isFetchInProgress = false
    }
  }

  async fetchSettingsData(): Promise<any> {
    try {
      this.isFetchInProgress = true
      this.setttingsKeyList = await this.fetchSettingData()
    } catch (e) {
      this.snackBar = true
      this.snackBarColor="error"
      this.snackBarMessage=this.$t('settingsPage.offerStructure.snackbarErrorMessage').toString()
    }finally {
      this.isFetchInProgress = false
    }
  }

   mounted () {
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>

</style>
